import BaseParametersFormattingStrategy from "../../parametersFormatting/BaseParametersFormattingStrategy";
import ParametersFormatter from "../../parametersFormatting/ParametersFormatter"
import UserNameFormat from "../../util/UserNameFormat"
import messageResource from "../../messageResource"
import ATReportParamsStringBuilder from '../../reports/reportParamsStringBuilder/ATReportParamsStringBuilder'
import DateRangeFormattingStrategy from '../../parametersFormatting/DateRangeFormattingStrategy'

const ParametersFormattingStrategy = function() {};

ParametersFormattingStrategy.prototype = _.create(BaseParametersFormattingStrategy.prototype, {

    createParametersFormatter: function({selectorsData, dateFormat}) {
        return new ParametersFormatter().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            reportParamsStringBuilderConstructor: ATReportParamsStringBuilder,
        })
    },

    createDateParametersFormattingStrategy: function(config) {
        return new DateRangeFormattingStrategy(config.dateFormat)
    },

    formatMainPartOfLightboxTitle: function(selectedParameters)
    {
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        if (selectedParameters.pageOwnerData.otherUser)
        {
            var user = selectedParameters.pageOwnerData.user;
            var userAsString = UserNameFormat.formatFML(user.firstName, user.lastName, user.middleName);
            return messageResource.getMessage("view_tt.pdf_preview.other_user_title", [userAsString, dateParameters]);
        }
        return messageResource.getMessage("view_tt.pdf_preview.my_title", [dateParameters]);
    },

    formatParametersText: function(selectedParameters)
    {
        var statusesFilter = ViewTTPageUtils.makeStatusFilterToDisplay(selectedParameters.statuses);
        var statuses = _.isNull(statusesFilter) ? "" : this.parametersFormatter.formatStatusesSelection(statusesFilter) +  "; ";
        return statuses + this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.cpSelection);
    }
});

export default ParametersFormattingStrategy


// WEBPACK FOOTER //
// ./web/js/user/viewtt/ParametersFormattingStrategy.js